import { render, staticRenderFns } from "./warn.vue?vue&type=template&id=ebe19010"
import script from "./warn.vue?vue&type=script&lang=js"
export * from "./warn.vue?vue&type=script&lang=js"
import style0 from "./warn.vue?vue&type=style&index=0&id=ebe19010&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports